// MotoristaAvaliacoes.tsx
import React from "react";
import {t} from "../../../lang/index"

type Avaliacao = {
  id: number;
  usuarioNome: string;
  usuarioFotoUrl?: string;
  nota: number;
  comentario: string;
  fotos?: number[];
  fotosPorPonto?: { fotoId: number; url: string; ponto?: string }[];
};

interface Props {
  avaliacoes: Avaliacao[];
  baseUrl: string;
  openLightbox: (slides: { src: string }[]) => void;
}

const MotoristaAvaliacoes: React.FC<Props> = ({ avaliacoes, baseUrl, openLightbox }) => {
  if (avaliacoes.length === 0) return <p>{t("home.driverModal.noReviews")}</p>;

  return (
    <div className="mt-3">
      {avaliacoes.map((av) => (
        <div key={av.id} className="card mb-2 p-2">
          <div className="d-flex align-items-center mb-2">
            <img
              src={av.usuarioFotoUrl ? `${baseUrl}${av.usuarioFotoUrl}` : "/assets/img/users/default-avatar.png"}
              className="avatar rounded-circle me-2"
              alt={av.usuarioNome}
              style={{ width: "40px", height: "40px" }}
            />
            <div>
              <strong>{av.usuarioNome}</strong>
              <span className="badge badge-warning badge-xs text-gray-9 fs-10 fw-medium ms-2 p-1">
                <i className="isax isax-star" /> {av.nota.toFixed(1)}
              </span>
            </div>
          </div>
          <p style={{ fontSize: "0.9rem", lineHeight: 1.4 }}>{av.comentario}</p>

          {(av.fotosPorPonto?.length || 0) > 0 || (av.fotos?.length || 0) > 0 ? (
            <div className="d-flex flex-wrap gap-2">
              {av.fotosPorPonto?.map((f) => (
                <div
                  key={`ponto-${f.fotoId}`}
                  style={{ width: "80px", height: "80px", cursor: "pointer", position: "relative" }}
                  onClick={() =>
                    openLightbox([
                      ...(av.fotos?.map((fid) => ({ src: `${baseUrl}/uploads/${fid}` })) || []),
                      ...(av.fotosPorPonto?.map((fp) => ({ src: `${baseUrl}${fp.url}` })) || []),
                    ])
                  }
                >
                  <img
                    src={`${baseUrl}${f.url}`}
                    alt={f.ponto || "foto"}
                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "6px" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      background: "rgba(0,0,0,0.5)",
                      color: "#fff",
                      fontSize: "0.7rem",
                      textAlign: "center",
                      borderBottomLeftRadius: "6px",
                      borderBottomRightRadius: "6px",
                    }}
                  >
                    {f.ponto}
                  </div>
                </div>
              ))}
              {av.fotos?.map((fid) => (
                <div
                  key={`foto-${fid}`}
                  style={{ width: "80px", height: "80px", cursor: "pointer" }}
                  onClick={() =>
                    openLightbox([
                      ...(av.fotos?.map((fid2) => ({ src: `${baseUrl}/uploads/${fid2}` })) || []),
                      ...(av.fotosPorPonto?.map((fp) => ({ src: `${baseUrl}${fp.url}` })) || []),
                    ])
                  }
                >
                  <img
                    src={`${baseUrl}/uploads/${fid}`}
                    alt="foto"
                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "6px" }}
                  />
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default MotoristaAvaliacoes;
